export const AFFILIATE_COOKIE = 'affiliate'

const AFFILIATE_RE = /^[A-Za-z0-9_-]{1,64}$/

export const isValidAffiliate = (v) => typeof v === 'string' && AFFILIATE_RE.test(v)

export const getAffiliate = (cookies) =>
  isValidAffiliate(cookies[AFFILIATE_COOKIE]) ? cookies[AFFILIATE_COOKIE] : null
